import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CookieService } from "src/app/services/cookie.service";
import { cookieNames } from "src/app/services/cookie.service";

@Component({
  selector: "app-paymentResult",
  templateUrl: "./paymentResult.component.html",
  styleUrls: ["./paymentResult.component.scss"],
})
export class PaymentResultComponent implements OnInit {
  private parentRouteResult: string;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private cookieService: CookieService,
  ) {}

  ngOnInit(): void {
    this.parentRouteResult = this.activatedRoute.snapshot.params.result;
    this.cookieService.deleteCookie(cookieNames.paymentResult);
  }

  navigateToHome() {
    this.router.navigate([""]);
  }

  get paymentResultSuccess() {
    return this.parentRouteResult === "success";
  }
}
